module.exports = __webpack_public_path__ + "static/media/pinterest-logo.02ef4bb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pinterest-logo.svg
// module id = 179
// module chunks = 0